import { render } from "./App.vue?vue&type=template&id=2e0b00f5"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2e0b00f5&lang=css"

import exportComponent from "/home/runner/work/eszti-isti.donko.hu/eszti-isti.donko.hu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__